webpackJsonp([116596815971312],{

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/160x600.77a91934.jpg";

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/300x250.4621f68c.jpg";

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/468x60.f21e7770.jpg";

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/728x90.7595a6a9.jpg";

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/discount-2400x1256.7ebfba0c.png";

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/general-1-1080x1080.942f6a69.jpg";

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/general-2-1920x1080.a395e888.jpg";

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/general-3-2400x1256.2c9b1562.jpg";

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tracks-640x960.66ec184a.png";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _x = __webpack_require__(563);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _x3 = __webpack_require__(564);
	
	var _x4 = _interopRequireDefault(_x3);
	
	var _x5 = __webpack_require__(565);
	
	var _x6 = _interopRequireDefault(_x5);
	
	var _x7 = __webpack_require__(566);
	
	var _x8 = _interopRequireDefault(_x7);
	
	var _general11080x = __webpack_require__(568);
	
	var _general11080x2 = _interopRequireDefault(_general11080x);
	
	var _general21920x = __webpack_require__(569);
	
	var _general21920x2 = _interopRequireDefault(_general21920x);
	
	var _general32400x = __webpack_require__(570);
	
	var _general32400x2 = _interopRequireDefault(_general32400x);
	
	var _discount2400x = __webpack_require__(567);
	
	var _discount2400x2 = _interopRequireDefault(_discount2400x);
	
	var _tracks640x = __webpack_require__(571);
	
	var _tracks640x2 = _interopRequireDefault(_tracks640x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MultimediaItem = function MultimediaItem(props) {
	    return _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	            'h5',
	            null,
	            props.size
	        ),
	        _react2.default.createElement('img', { className: 'img-responsive', src: props.image })
	    );
	};
	
	var PressRelease = function PressRelease(props) {
	    return _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('h5', null),
	        _react2.default.createElement(
	            'a',
	            { href: props.source, target: '_blank' },
	            props.title
	        )
	    );
	};
	
	var Multimedia = function Multimedia() {
	    return _react2.default.createElement(
	        'section',
	        { id: 'multimedia', className: 'parallax-section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'team-wrapper' },
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'These are the multimedia materials that our partners are allowed to use for DevExperience 2019'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Press releases'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(PressRelease, { source: '../press-release/Comunicat-de-Presa-DevExperience-2019.pdf', title: 'Comunicat de presa in romana' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(PressRelease, { source: '../press-release/Press-Release-DevExperience-2019.pdf', title: 'English Press Release' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(MultimediaItem, { size: '728x90', image: _x8.default })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(MultimediaItem, { size: '468x60', image: _x6.default })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(MultimediaItem, { size: '300x250', image: _x4.default })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(MultimediaItem, { size: '160x600', image: _x2.default })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-4' },
	                                    _react2.default.createElement(MultimediaItem, { size: '2400x1256', image: _general32400x2.default })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-4' },
	                                    _react2.default.createElement(MultimediaItem, { size: '1920x1080', image: _general21920x2.default })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-4' },
	                                    _react2.default.createElement(MultimediaItem, { size: '1080x1080', image: _general11080x2.default })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(MultimediaItem, { size: '2400x1256', image: _discount2400x2.default })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6' },
	                                    _react2.default.createElement(MultimediaItem, { size: '640x960', image: _tracks640x2.default })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Multimedia;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-multimedia-js-bcadfdf7b35c188531eb.js